export default function Reducer(prevState, action){
    switch (action.type) {
        case "IS_LOADING":
            return {
                ...prevState,
                is_loading: true,
            };
        case "IS_LOADED": 
            return {
                ...prevState,
                total_holidays: action.total_holidays,
                total_pages: action.total_pages,
                holiday_list: action.holiday_list,
                current_page: action.current_page,
                is_loading: false,
            };
        case "UPDATE_CURRENT_PAGE":
            return {
                ...prevState,
                current_page: action.current_page,
            };
        case "SET_SERACH_VALUE":
            return {
                ...prevState,
                current_page: 1,
                search_value: action.search_value,
            }; 
        case "SET_SORT_CONFIG":
            return {
                ...prevState,
                sort_key: action.sort_key,
                sort_direction: action.sort_direction,
            };
        default:
            throw new Error();
    }
}